<div class="app-chat-container">
  <!-- This is the title bar -->
  <header *ngIf="showHeader" style="margin-bottom: 10px;">
    <nav class="navbar navbar-inverse brand-color">
      <!-- Navbar content -->
      <div class="row" style="width:100%;">
        <div class="col-1" style="padding:unset;">
          <img class="rounded" src="assets/brand/esme_icon.svg" alt="Esme Icon" />
        </div>
        <div class="col-3" style="padding-top: .5rem;">
          <span>Ask
            <i>Esme!</i>
          </span>
          <!-- <i class="fa fa-comment fa-2x" aria-hidden="true"></i> -->
        </div>
        <div class="col-8">
          <div *ngIf = "liveChat"style="position: absolute; top: 6px; right: 180px;" aria-hidden="true" aria-label="Live agent connected">Live</div>
          <div *ngIf = "liveChat" class="blinking-green" style="position: absolute; top: 11px; right: 160px;" aria-hidden="true" aria-label="Live agent connected"></div>
          <span class="float-right" style="padding-top: .5rem;">
            Chat reference: {{ chatTransactionId }}
          </span>
        </div>
      </div>
    </nav>
  </header>

  <main>
    <div *ngIf = "liveChat" style="position: absolute; top: 6px; right: 180px;" aria-hidden="true" aria-label="Live agent connected">Live</div>
    <div  *ngIf = "liveChat" class="blinking-green" style="position: absolute; top: 11px; right: 160px;" aria-hidden="true" aria-label="Live agent connected"></div>
    <div *ngIf="!showHeader && chatTransactionId" class="chat-ref float-right">
      Chat reference: {{chatTransactionId}}
    </div>

    <div #messagesParentDiv id="messagesParentDiv" class="container-fluid messagesContainer"
      [style.height.px]="messagesParentDivHeight" appBotScrollBottom>
      <div class="row" *ngFor="let message of allMessages; let isLast=last">
        <div class="col-12">
          <app-chat-message [message]="message" [isActive]="isLast" (selectedItem)="selectedItem($event)"
            (selectedOption)="selectedOption($event)" (selectedListItem)="selectedListItem($event)">
          </app-chat-message>
        </div>
      </div>
    </div>
  
    <div class="container-fluid" style="min-height: 2.5rem">
      <app-quick-response [requestInProgress]="!showYesNo" (selectedResponse)="selectedResponse($event)"
        [quickResponseButtonSetInput]="quickResponseButtonSetInput"></app-quick-response>
    </div>

    <div class="container-fluid bot-reply-loader" *ngIf="requestInProgress">
      <img class="rounded" src="assets/loading.gif" />
    </div>
  </main>

  <footer #popover="ngbPopover" [ngbPopover]="popoverContent" triggers="manual"
   (keyup)="autoShowHidePopover(popover)">
    <div class="container-fluid fixedFooter app-chat-container">
      <div class="row" *ngIf="allMessages && allMessages.length > 0">
        <div class="col-12" style="background-color: white;">
          <div style="padding-top: 7px;">
            <button *ngIf="showAttachments" id="add-attachments" role="button"
              [ngbPopover]="attachmentsForm" [autoClose]="'outside'" #p="ngbPopover" (hidden)="attachmentError = ''"
              class="btn button-attach" type="button" (mouseover)="!disableChatInput && myImgSrc = '/assets/askuploadHover.svg'"
              (mouseout)="myImgSrc = '/assets/askupload.svg'" [disabled]="disableChatInput || liveChat" [ngClass]="{'chatdisabledbuttons' : disableChatInput || liveChat}">
              <img [ngClass]="{'chatdisabledbuttons': disableChatInput || liveChat}" id="file-input-img" class="rounded" 
                [src]="myImgSrc" alt="Esme Icon" style="width:1.4rem;padding-bottom:3px;margin-right:2px"/>
              Attach Photos
            </button>
            <button id="restart-chat" role="button" style="float:right;"
              class="btn button-attach" type="button" (mouseover)="myCloseChat = '/assets/cancelchathover.svg'"
              (mouseout)="myCloseChat = '/assets/cancelchat.svg'" (click)="reload()">
              <!-- 
              (mouseover)="!disableChatInput && myCloseChat = '/assets/cancelchathover.svg'"
              [disabled]="disableChatInput"  [ngClass]="{'chatdisabledbuttons' : disableChatInput}"> -->
              {{ liveChat ? 'End Live Chat' : 'Restart Chat' }}
              <img  id="file-input-img" class="rounded" 
                [src]="myCloseChat" alt="Esme Icon" style="width:1.4rem;padding-bottom:3px;margin-left: 2px;" />
                <!-- [ngClass]="{'chatdisabledbuttons' : disableChatInput}" -->
            </button>
            
          </div>
          <div style="margin-bottom: 10px;padding-top: 7px;" class="input-group">
            <input id="message-entry" type="text" [(ngModel)]="draftMessage.text" [disabled]="disableChatInput"
              [ngClass]="{'chatdisabled' : disableChatInput}"
              class="form-control dda-color-contrast-input shadow-none" 
              placeholder="Write your message here..." (keydown.enter)="onEnter($event)" />
            <span class="input-group-btn" style="padding-left: 16px;">
              <button id="submit-button" role="button" type="button" title="Submit" 
                class="btn btn-primary" [ngClass]="{'chatdisabled' : disableChatInput}"
                style="padding-top: 5px;height: 38px;" [disabled]="disableChatInput || !draftMessage.text" 
                (click)="onEnter($event)" (mouseout)="myImgSrcPaperPlane='assets/paperplane.png'"
                (mouseover)="draftMessage.text && myImgSrcPaperPlane='assets/paper-plane-solid.svg'">
                <img [src]="myImgSrcPaperPlane" alt="Submit" style="width:1.2rem" role="tooltip"/>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
@if (requestInProgress && showLoading) {
  <app-loading [showLoading]="true" [loadingMessage]="loadingMessage"></app-loading>
}
<ng-template #casePopContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
  </div>
  <div class="modal-body">
    <p [innerHTML]="modalMessage"></p>
  </div>
  <div class="modal-footer">

    <button *ngFor="let button of modalButtons" type="button" class="btn" [ngClass]="button.primary ? 'button-attach' :'btn-light'" (click)="modal.close(button.key)">
      {{button.value}}
    </button>
  </div>
</ng-template>

<ng-template #attachmentsForm>
  <div class="card" style="margin-top:-9px;width:550px;margin-left:-12px;margin-bottom:-9px">
    <div class="card-header dformTextColor">
      <p style="font-size:large;"> Attached images</p>
      <p *ngIf="attachmentError" class="card-text" [innerHTML]="attachmentError"></p>
      <p *ngIf="!attachmentError">
        <small>A maximum of 5 images can be added to your request when submitted. Please avoid uploading any sensitive
           or confidential information including photos containing other individuals or equipment without their permission</small>
      </p>
    </div>

    <div class="row" style="padding:1rem;margin-left:0px" aria-label="Attach Photos">
      <div *ngFor="let attachment of formCreateCaseContext.attachments" class="card col"
        style="max-width: 6rem;border:none">
        <img [src]="attachment.url" alt="{{attachment.name}}"
          style="width: 3rem;height:5rem;background-color: #e4ecf3;">
        <p class="text-muted" style="font-size: 11px;">
          {{attachment.name}}
        </p>
      </div>

      <div id="attachment-box" *ngIf="formCreateCaseContext.attachments.length < 5" 
        class="card col" tabindex="0" (keydown)="attachKeyDown($event)" role="button">
        <label id="attachment-input" for="file-input" class="btn btn-primary" title="Attach Photos">
          <img id="attachment-image" src="assets/brand/Add_Icon.png" title="Attach Photos">
        </label>
        <input type="file" id="file-input" accept="image/x-png,image/gif,image/jpeg" multiple
        (change)="handleFileInput($event.target.files)" style="display: none;">
      </div>
    </div>
  </div>
</ng-template>